import React from 'react'
import Executive from '../components/Executive'

const Team = () => {
  return (
   <>
   <Executive/>
   </>
  )
}

export default Team